import { Form } from 'factorial-form'
import compact from 'lodash/compact'
import { makeObservable, observable } from 'mobx'

import type { FilterParams } from 'modules/reports/store/models/Filter'

import ConditionFormCollection from './Condition'
import type ConditionForm from './Condition/ConditionForm'

class FilterForm extends Form {
  conditions: ConditionFormCollection<ConditionForm> | undefined

  static buildForms(params: FilterParams[]): FilterForm[] {
    return params.map((filter) => {
      const filterForm = new FilterForm(filter)
      filterForm.buildConditions(filter)

      return filterForm
    })
  }

  static convertToParams(forms: FilterForm[]): FilterParams[] {
    return compact(forms.map((f: FilterForm) => f.conditions?.convertToParams()))
  }

  constructor(values: Record<string, any> = {}) {
    super(values, {
      id: 'string',
    })
    makeObservable(this, {
      conditions: observable,
    })
  }

  buildConditions(filter?: FilterParams) {
    this.conditions = new ConditionFormCollection({
      filter,
    })
  }
}

export default FilterForm
